var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmail = function SvgEmail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.25C2.5 5.22461 3.32031 4.375 4.375 4.375H15.625C16.6504 4.375 17.5 5.22461 17.5 6.25V13.75C17.5 14.8047 16.6504 15.625 15.625 15.625H4.375C3.32031 15.625 2.5 14.8047 2.5 13.75V6.25ZM3.90625 6.25V6.92383L8.94531 11.0547C9.56055 11.5527 10.4102 11.5527 11.0254 11.0547L16.0938 6.92383V6.25C16.0938 6.01562 15.8594 5.78125 15.625 5.78125H4.375C4.11133 5.78125 3.90625 6.01562 3.90625 6.25ZM3.90625 8.74023V13.75C3.90625 14.0137 4.11133 14.2188 4.375 14.2188H15.625C15.8594 14.2188 16.0938 14.0137 16.0938 13.75V8.74023L11.9336 12.1387C10.791 13.0762 9.17969 13.0762 8.03711 12.1387L3.90625 8.74023Z",
    fill: "#667085"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "email.9c5246b6859d0b0ad5ed23554c83e50a.svg";